import { useState } from 'react';
import { Text, Flex, Button } from '@chakra-ui/react';
import { SectionBox } from 'src/components/SectionBox';
import CenteredSpinner from '@/components/CenterSpinner/CenteredSpinner';

import { useFiltersForm } from '@/utils/useFiltersForm';
import { GetParamsObject } from '@/model/query-params';
import { NotificationsTabFilterBox } from '../NotificationsTabFilterBox';
import { NotificationsTabTable } from '../NotificationsTabTable';
import { NotificationsTabFilters } from '../../types';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { NotificationCreateModal } from '../NotificationCreateModal';
import { useNotifications } from '@/services/queries/notification-push';

export const NotificationsTab = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const filtersForm = useFiltersForm<NotificationsTabFilters>({
    defaultValues: {
      search: '',
      startDate: '',
      endDate: '',
      status: '',
    },
  });
  const filterData = filtersForm.watch();

  const [sorting, setSorting] = useState<{ field: string; desc: boolean }>({ field: 'created_at', desc: true });
  const [pagination, setPagination] = useState<{ pageNumber: number; pageSize: number }>({
    pageNumber: 1,
    pageSize: 10,
  });

  const params = GetParamsObject(
    filterData,
    pagination.pageNumber,
    pagination.pageSize,
    sorting.desc ? 'desc' : 'asc',
    sorting.field,
  );

  const { data: itemData, isLoading: isLoadingItem, forceRefetch: forceRefetchItems } = useNotifications(params);

  const itemsData = itemData?.data || [];

  const onHandleCreate = () => {
    setIsCreateModalOpen(true);
  };

  const onHandleCreateDone = () => {
    setIsCreateModalOpen(false);
    forceRefetchItems();
  };

  return (
    <Flex direction='column'>
      <Flex justifyContent='space-between' alignItems='center' gap={2} mb={6}>
        <Flex direction='column'>
          <Text fontWeight='bold'>Notificações</Text>
          <Text fontSize='12px'>Envie comunicados, novidades e promoções para os usuários do aplicativo</Text>
        </Flex>

        <Button display='flex' alignItems='center' gap={2} onClick={onHandleCreate} width={{ base: '100%', md: 'initial' }}>
          <ChakraFeatherIcon name='plus-circle' />
          Criar nova notificação
        </Button>
      </Flex>

      <SectionBox bodyProps={{ gap: 'small' }}>
        <NotificationsTabFilterBox filtersForm={filtersForm} forceRefetch={forceRefetchItems} />
      </SectionBox>

      <Flex direction='column' gap='deka' mt={8}>
        <NotificationsTabTable
          data={itemsData}
          isLoading={isLoadingItem}
          sorting={sorting}
          pageNumber={pagination.pageNumber}
          pageSize={pagination.pageSize}
          totalPages={itemData?.meta.pages ?? 0}
          totalItems={itemData?.meta.total ?? 0}
          onSortingChange={(field, desc) => setSorting({ field, desc })}
          onPaginationChange={(pageNumber, pageSize) => setPagination({ pageNumber, pageSize })}
        />
      </Flex>

      <NotificationCreateModal
        isOpen={isCreateModalOpen}
        onClose={() => {
          setIsCreateModalOpen(false);
        }}
        onDone={onHandleCreateDone}
      />

      <CenteredSpinner isLoading={isLoadingItem} />
    </Flex>
  );
};
